import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 6H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 12H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 18H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M11 10v4h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListRestart";
const ListRestart = memo(themed(Icon));
export {
  ListRestart
};
//# sourceMappingURL=list-restart.js.map
